import { render, staticRenderFns } from "./last-orders-table.vue?vue&type=template&id=55823f23&"
import script from "./last-orders-table.vue?vue&type=script&lang=js&"
export * from "./last-orders-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports